import { useEffect, useRef } from 'react'
import { markdownParser } from 'prose-core'
import { PreviewContentData } from 'common/Prose/nodeViews/AISuggestion/PreviewContentData'
import { EditorView } from 'prosemirror-view'
import { fetchStream } from './utils'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  jobId: string
  view: EditorView
  streamContent: string
  setStreamContent: React.Dispatch<React.SetStateAction<string>>
  className?: string
}

export const StreamContentData = ({ jobId, view, className, streamContent, setStreamContent }: Props) => {
  const topRef = useRef<HTMLDivElement | null>(null)
  const bottomRef = useRef<HTMLDivElement | null>(null)
  const { isMobile } = useResponsiveDesign()

  useEffect(() => {
    fetchStream({
      jobId,
      onParsedLine: (line: string) => {
        setStreamContent((streamContent) => streamContent + line)
        if (!isMobile) bottomRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      },
      onLastLineParsed: () => {
        if (!isMobile) topRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      },
    })
    return () => {}
  }, [jobId]) // eslint-disable-line react-hooks/exhaustive-deps

  const contentData = JSON.stringify(markdownParser.parse(streamContent)?.toJSON().content || [])

  return (
    <>
      <div ref={topRef} />
      <PreviewContentData contentData={contentData} view={view} className={className} />
      <div ref={bottomRef} />
    </>
  )
}
